{
  "dataType": {
    "products": "products",
    "customers": "customers",
    "merchant": "merchants",
    "purchases": "purchases",
    "pricing": "prices",
    "companies": "companies",
    "company_location": "locations",
    "company_contact": "location customers"
  }
}
